import { Navigate, Outlet, useOutletContext } from 'react-router-dom';
import { useAppContext } from '../provider/contexts';
import { StoreMgmtOutletContext } from '@/types/pages/storeManagement/context';

interface ProtectedAdminRouteProps {
    requiredLevel: number;
}

function ProtectedAdminRoute({ requiredLevel }: ProtectedAdminRouteProps) {
    const { userDetails } = useAppContext();
    const outletContext = useOutletContext<StoreMgmtOutletContext>();
    if (!userDetails) {
        return <Navigate to="/login" replace />;
    }
    if (userDetails?.user_level < requiredLevel) {
        return <Navigate to="/corporation-selection" replace />;
    }

    return <Outlet context={outletContext} />;
}

export default ProtectedAdminRoute;
